import React from 'react';
import { Link } from 'react-router-dom';

// Renders the approved copy as-is, turning **bold**, `Label (/path)` links and
// bare email addresses into elements. No new styling: everything inherits the
// surrounding typography.
export function inline(text) {
  const parts = [];
  const pattern = /\*\*(.+?)\*\*|([A-Za-z][A-Za-z0-9 ,'&–-]*?)\s\((\/[a-z0-9-/]*)\)|([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,})/g;
  let last = 0;
  let m;
  let key = 0;
  while ((m = pattern.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[1]) {
      parts.push(<strong key={key++} className="text-outline font-bold">{m[1]}</strong>);
    } else if (m[2]) {
      parts.push(
        <Link key={key++} to={m[3]} className="text-surface-tint font-semibold hover:text-primary transition-colors">
          {m[2].trim()}
        </Link>
      );
    } else if (m[4]) {
      parts.push(
        <a key={key++} href={`mailto:${m[4]}`} className="text-surface-tint font-semibold hover:text-primary transition-colors break-all">
          {m[4]}
        </a>
      );
    }
    last = pattern.lastIndex;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

export default inline;
